<template>
  <div>
    <div class="body container">
      <!--导航-->
      <div class="nav clearfix">
        <a
          :class="{'active':column.id == columnid}"
          href="#"
          v-for="column in brotherColumnData"
          :key="column.id"
          @click="changeColumn(column.id, column.fix_column_name)"
        >{{column.title}}</a>
      </div>
      <div class="selectWrap">
        <h4 class="tip">筛选</h4>
        <div class="selectBox">
          <!-- <div class="common">
            <span class="text">年级:</span>
            <div class="common-box">
              <a @click="search_grade(0)" :class="grade ==0 ? 'active' : '' ">全部</a>
              <a
                @click="search_grade(item.gradeid)"
                v-for="item in gradeData"
                :key="item.gradeid"
                :class="grade==item.gradeid ? 'active' : '' "
              >{{item.gradename}}</a>
            </div>
          </div>
          <div class="common">
            <span class="text">学科:</span>
            <div class="common-box">
              <a @click="search_subject(0)" :class="subject==0 ? 'active' : '' ">全部</a>
              <a
                @click="search_subject(item.id)"
                v-for="item in subjectData"
                :key="item.id"
                :class="subject==item.id ? 'active' : '' "
              >{{item.name}}</a>
            </div>
          </div> -->

          <div class="common">
            <span class="text">学年:</span>
            <div class="common-box">
              <div class="select-box">
                <el-select v-model="year" placeholder="学年" @change="search">
                  <el-option
                    v-for="item in this.yearData"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  ></el-option>
                </el-select>
                <el-select v-model="term" placeholder="学期" @change="search">
                  <el-option
                    v-for="item in this.termData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content wrapper clearfix">
        <div class="video-list fr" style="background: #f6f9fa;width: 100%">
          <div class="sortBox clearfix">
            <div class="sort fl">
              <a href="JavaScript:;" @click="status_sort(0)" :class="this.active_0">全部</a>
              <a href="JavaScript:;" @click="status_sort(2)" :class="this.active_2">正在直播</a>
              <a href="JavaScript:;" @click="status_sort(1)" :class="this.active_1">即将开始</a>
              <a href="JavaScript:;" @click="status_sort(3)" :class="this.active_3">直播历史</a>
            </div>
            <div class="searchBox fr">
              <span class="des">共{{this.count}}条结果</span>
              <div>
                <el-input
                  v-model="keyword "
                  placeholder="标题关键字"
                  class="handle-input mr10 keyword"
                  @keyup.enter.native="search"
                ></el-input>
                <a @click="search" class="searchBtn" href="javascript:"></a>
              </div>
            </div>
          </div>
          <ul class="video clearfix" v-loading="loading">
            <li class="videoList" v-for="item in data" :key="item.id">
              <a class="cover" href="JavaScript:;" @click="toInfo(item)">
                <img :src="item.logo_resid" :onerror="errorImg" :alt="item.title" />
                <div class="coverTitle">{{item.cn_status}}</div>
              </a>
              <div class="videoInfo">
                <a
                  class="title"
                  href="JavaScript:;"
                  @click="toInfo(item)"
                  :title="item.title"
                >{{item.title}}</a>
                <div>
                  <span class="auth" style="float:left">
                    <i></i>
                    <em>{{item.permission_scope==1?'公开':'本校'}}</em>
                  </span>
                  <span class="num" style="float:right">
                    <i></i>
                    <em>{{item.browse_count}}</em>
                  </span>
                  <br />
                  <span class="username" style="float:left">
                    <i></i>
                    <em>{{item.username}}</em>
                  </span>
                </div>
              </div>
            </li>
          </ul>
          <div class="noData" v-if="isShow">
            <img src="../../assets/img/no_video.png" />
            <p>暂无学习资源，去别的地方看看吧~</p>
          </div>
          <div class="btnGroup" style="background: #f6f9fa">
            <div class="pagination">
              <el-pagination
                background
                hide-on-single-page
                @current-change="PageChange"
                layout="prev, pager, next"
                :total="count"
                :current-page="page"
                :page-size="pageSize"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "school_webcast_class",
  data() {
    return {
      loading: false,
      errorImg: 'this.src="' + require("../../assets/img/onliveDf.png") + '"', // 图片损坏默认图
      isShow: false,
      columnid: this.$route.query.id, // 栏目id
      schoolid: this.$route.query.schoolid, // 学校id
      active_0: "active",
      active_1: "",
      active_2: "",
      active_3: "",
      page: 1,
      login_userid: globalApi.GetUserID(),
      pageSize: 24,
      count: 0,
      grade: 0,
      subject: 0,
      year: "",
      term: "",
      keyword: "",
      data: "", // 列表数据
      gradeData: "",
      subjectData: "",
      yearData: "",
      brotherColumnData: [], // 二级导航数据
      termData: [
        {
          value: "0",
          label: "学期"
        },
        {
          value: "1",
          label: "上学期"
        },
        {
          value: "2",
          label: "下学期"
        }
      ]
    };
  },
  computed: {
     globalVaranthasInited(){
         return globalApi.gWebsiteSessionInfo.hasInited;
     }
  },
  watch: {
      globalVaranthasInited: function(){        
        
        this.init();
      },
  },
  created() {
    
  },

  methods: {
    init(){
         this.getData();
        this.getGrade();
        this.getYearList();
        this.GetSchoolInfo();
        this.getBrotherColumn();
      },
    // 分页导航
    PageChange(val) {
      this.page = val;
      this.getData();
    },
    // 学校信息
    async GetSchoolInfo() {
      let data = {
        s: "WebSchoolSpace.Common.GetInfo"
      };
      const response = await globalApi.post( data);
      this.schooltypeid = response.data.data.info.schooltypeid;

      this.getSubject();
    },

    // 根据学校类型获取学科接口
    async getSubject() {
      const data = {
        s: "WebSchoolSpace.Common.getSubjectBySchoolType",
        type: this.schooltypeid
      };

      const response = await globalApi.post( data);
      const res = response.data.data;
      this.subjectData = res;
    },
    //根据年级获取学科
    async getSubjectByGrade() {
      const data = {
        s: "WebSchoolSpace.Common.getSubjectByGrade",
        grade: this.grade
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      this.subjectData = res;
    },

    // 获取二级导航
    async getBrotherColumn() {
      let data = {
        s: "WebSchoolSpace.Column.GetBrotherColumn",
        columnid: this.columnid,
        weblevel: 1,
        incdisabled: 1
      };

      let res = await globalApi.post( data);
      this.brotherColumnData = res.data.data.reverse();
    },

    // 获取数据接口
    async getData() {
      document.documentElement.scrollTop = 0;
      this.loading = true;
      const data = {
        s: "WebSchoolSpace.WebCast.getList",
        page: this.page,
        page_size: this.pageSize,
        grade: this.grade,
        subject: this.subject,
        year: this.year,
        term: this.term,
        keyword: this.keyword,
        type: 5, // 直播课堂类型
        status: this.status // /排序方式 1-即将开始 2-正在播放 3-直播历史
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      this.loading = false;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      this.count = res.recordcount;
      this.data = res.list;
      this.count == 0 ? (this.isShow = true) : (this.isShow = false);
    },

    // 关键词搜索
    search() {
      this.page = 1;
      this.getData();
    },

    // 排序
    status_sort(type) {
      if (type == 0) {
        this.active_0 = "active";
        this.active_1 = "";
        this.active_2 = "";
        this.active_3 = "";
        this.status = 0;
      } else if (type == 1) {
        this.active_0 = "";
        this.active_1 = "active";
        this.active_2 = "";
        this.active_3 = "";
        this.status = 1;
      } else if (type == 2) {
        this.active_0 = "";
        this.active_1 = "";
        this.active_2 = "active";
        this.active_3 = "";
        this.status = 2;
      } else if (type == 3) {
        this.active_0 = "";
        this.active_1 = "";
        this.active_2 = "";
        this.active_3 = "active";
        this.status = 3;
      }
      this.getData();
    },

    // 获取年级接口
    async getGrade() {
      const data = {
        s: "WebSchoolSpace.Common.getGrade"
      };
      const response = await globalApi.post( data);
      const res = response.data.data;
      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      this.gradeData = res;
    },

    // 获取学年接口
    async getYearList() {
      const data = {
        s: "WebSchoolSpace.Common.getYearList",
        gradeid: this.grade
      };

      const response = await globalApi.post( data);
      const res = response.data.data;

      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }

      this.yearData = res;
    },

    // 搜索年级
    search_grade(val) {
      this.page = 1;
      this.grade = val;
      this.getData();
      this.getGrade();
      if (this.grade == 0) {
        this.getSubject();
      } else {
        this.getSubjectByGrade();
      }
    },

    // 搜索学科
    search_subject(val) {
      this.page = 1;
      this.subject = val;
      this.getData();
    },

    // 详情页跳转
    // id       -课堂直播id
    // powerId  -课堂直播权限
    // schoolid -课堂直播学校id
    // status   -课堂直播状态
    async toInfo(val) {
      const isView = globalApi.checkViewPower(val.permission_scope,val.schoolid);

      if (isView == 1) {
        if (val.status == 2) {
          globalApi.jumpPath(2, "school_webcast_live_info", "id=" + val.id); // 跳转直播页面
        } else {
          globalApi.jumpPath(2, "school_webcast_class_info", "id=" + val.id); // 跳转视频播放页面
        }
      }
      if (isView == 2) {
        let fromurl = encodeURIComponent(location.href);
        location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
      }
      if (isView == 3) {
        this.$message.error("无访问权限!");
      }
    },

    // 二级导航跳转
    changeColumn(id, address) {
      this.$router.push(
        String(
          address + "?id=" + id + "&schoolid=" + this.$route.query.schoolid
        )
      );
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
</style>
<style scoped>
.select-box .el-select {
  margin-right: 20px;
}
.keyword {
  width: 90%;
}
#year {
  float: left;
  margin-right: 10px;
}
#term {
  float: left;
}

.btnGroup {
  clear: both;
}
.video .videoList .videoInfo .title {
  padding-bottom: 1px;
}
.video .videoList .videoInfo {
  padding: 3px 10px !important;
}
</style>
